import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { openSourcePackages } from '../config/openSource';
import './OpenSourcePage.css';

interface PackageFeature {
  emoji: string;
  title: string;
  description: string;
}

const OpenSourcePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="open-source-page">
      <section className="page-header">
        <div className="container">
          <h1 className="page-title">{t('openSource.title')}</h1>
          <p className="page-subtitle">{t('openSource.subtitle')}</p>
        </div>
      </section>

      <section className="open-source-content">
        <div className="container">
          <div className="open-source-grid">
            {openSourcePackages.map((pkg) => {
              const i18nBase = `openSource.packages.${pkg.i18nKey}`;
              const featuresResult = t(`${i18nBase}.features`, { returnObjects: true });
              const features = Array.isArray(featuresResult)
                ? (featuresResult as PackageFeature[])
                : [];

              return (
                <article key={pkg.id} className="open-source-card">
                  <div className="open-source-card-header">
                    <span className="open-source-platform">{pkg.platform}</span>
                    <h2 className="open-source-name">{t(`${i18nBase}.name`)}</h2>
                    <p className="open-source-card-subtitle">{t(`${i18nBase}.subtitle`)}</p>
                  </div>

                  <div className="open-source-card-body">
                    <p className="open-source-description">{t(`${i18nBase}.description`)}</p>

                    {features.length > 0 && (
                      <ul className="open-source-feature-list">
                        {features.map((feature) => (
                          <li key={feature.title} className="open-source-feature-item">
                            <span className="open-source-feature-emoji" aria-hidden="true">
                              {feature.emoji}
                            </span>
                            <div>
                              <div className="open-source-feature-title">{feature.title}</div>
                              <div className="open-source-feature-desc">{feature.description}</div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    )}

                    <div className="open-source-actions">
                      <a
                        href={pkg.githubUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary btn-large"
                      >
                        {t('openSource.viewOnGitHub')}
                      </a>
                      <Link to={pkg.demoPath} className="btn btn-secondary btn-large">
                        {t('openSource.viewDemo')}
                      </Link>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OpenSourcePage;
